import React from 'react';
import Popover from '@material-ui/core/Popover';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Box } from '@material-ui/core';
import useStyles from '../../screens/Main/Main.style';

const EditOptions = ({
  handleEditClickOpen,
  handleClickDelete,
  editPermission,
  deletePermission,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box display="flex">
      <MoreHorizIcon
        className={classes.EditOptionsIcon}
        aria-describedby={id}
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box className={classes.EditOptions}>
          <If condition={editPermission}>
            <Box
              className={classes.EditOptionsList}
              onClick={() => {
                handleClose();
                handleEditClickOpen();
              }}
            >
              Edit
            </Box>
          </If>
          <If condition={deletePermission}>
            <Box
              className={classes.EditOptionsList}
              onClick={() => {
                handleClose();
                handleClickDelete();
              }}
            >
              Delete
            </Box>
          </If>
        </Box>
      </Popover>
    </Box>
  );
};

export default EditOptions;
